export default "__VITE_ASSET__db1974b2__"